import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CmsUrl, PrimaryFooterLink } from '@digital-platform/rs-cms/domain';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';
import { RichTextLinkComponent } from '../rich-text-link/rich-text-link.component';

@Component({
  selector: 'digital-platform-primary-footer-link',
  standalone: true,
  imports: [CommonModule, RichTextLinkComponent],
  templateUrl: './primary-footer-link.component.html',
  styleUrls: ['./primary-footer-link.component.scss'],
})
export class PrimaryFooterLinkComponent
  extends BasePTypeComponent
  implements PrimaryFooterLink
{
  public override type = 'primaryFooterLink' as const;

  @Input() aTarget: PrimaryFooterLink['aTarget'] = null;
  @Input() url: PrimaryFooterLink['url'] = {} as CmsUrl; // CmsUrlFields.options can either be `CmsUrlOptions` or `[]`, however Typescript won't allow properly setting this type since there's no overlap between an object and an array.
}
